import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { PRODUCTS, waLink } from "./constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { nome: "", whatsapp: "", produto: "", quantidade: "", mensagem: "" };
const field = "w-full border-0 border-b border-white/20 bg-transparent px-0 py-3 text-base text-white placeholder:text-stone-500 outline-none transition-colors focus:border-[#FACC15]";
const label = "font-mono-x text-[11px] uppercase tracking-[0.2em] text-stone-400";

export const ContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nome.trim() || form.whatsapp.replace(/\D/g, "").length < 8 || !form.produto) {
      toast.error("Preencha nome, WhatsApp válido e produto de interesse.");
      return;
    }
    setLoading(true);
    const text = `Olá, Destak! Gostaria de um orçamento.\n\nNome: ${form.nome}\nWhatsApp: ${form.whatsapp}\nProduto: ${form.produto}\nQuantidade: ${form.quantidade || "-"}\nMensagem: ${form.mensagem || "-"}`;
    window.open(waLink(text), "_blank", "noopener");
    try {
      await axios.post(`${API}/quotes`, form);
    } catch (err) {
      console.error("quote save failed", err);
    }
    toast.success("Solicitação enviada! Continue a conversa no WhatsApp.");
    setForm(EMPTY);
    setLoading(false);
  };

  return (
    <form onSubmit={submit} className="grid grid-cols-1 gap-8 sm:grid-cols-2" data-testid="contact-form">
      <label className="block"><span className={label}>Nome</span>
        <input value={form.nome} onChange={set("nome")} placeholder="Seu nome" className={field} data-testid="contact-nome-input" />
      </label>
      <label className="block"><span className={label}>WhatsApp</span>
        <input value={form.whatsapp} onChange={set("whatsapp")} inputMode="tel" placeholder="(92) 9 0000-0000" className={field} data-testid="contact-whatsapp-input" />
      </label>
      <div className="block"><span className={label}>Produto de interesse</span>
        <Select value={form.produto} onValueChange={(v) => setForm((f) => ({ ...f, produto: v }))}>
          <SelectTrigger className="h-auto rounded-none border-0 border-b border-white/20 bg-transparent px-0 py-3 text-base text-white shadow-none focus:ring-0 data-[placeholder]:text-stone-500" data-testid="contact-produto-select">
            <SelectValue placeholder="Selecione" />
          </SelectTrigger>
          <SelectContent className="border-white/10 bg-[#15100c] text-white">
            {[...PRODUCTS.map((p) => p.name), "Outros / Madeiras"].map((n) => (
              <SelectItem key={n} value={n} className="focus:bg-[#FACC15] focus:text-[#0c0a09]" data-testid={`contact-produto-option-${n.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{n}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <label className="block"><span className={label}>Quantidade</span>
        <input value={form.quantidade} onChange={set("quantidade")} placeholder="Ex.: 20 chapas" className={field} data-testid="contact-quantidade-input" />
      </label>
      <label className="block sm:col-span-2"><span className={label}>Mensagem</span>
        <textarea value={form.mensagem} onChange={set("mensagem")} rows={4} placeholder="Espessura, medidas, prazo..." className={`${field} resize-none`} data-testid="contact-mensagem-input" />
      </label>
      <div className="sm:col-span-2">
        <button type="submit" disabled={loading} className="btn-yellow btn-lg w-full sm:w-auto" data-testid="contact-submit-btn">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-5 w-5" />} Enviar solicitação
        </button>
      </div>
    </form>
  );
};
